<div class="page traveler">
    <mat-tab-group disableRipple class="dialog-table" mat-stretch-tabs="false">
      <mat-tab label="Lock policies">
        <lock-policy-table></lock-policy-table>
      </mat-tab>
    </mat-tab-group>
  </div>
